import Keycloak from 'keycloak-js';

export const redirectUri = process.env.REACT_APP_REDIRECT_URI;
export const url = process.env.REACT_APP_KEYCLOAK_BASE_URL;
export const realm = process.env.REACT_APP_KEYCLOAK_REALM;
export const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;

export const keycloakConfig = {
  url,
  realm,
  clientId
};

export const forgotPasswordLink = `${url}/realms/${realm}/login-actions/reset-credentials?client_id=${clientId}`;

const _kc = new Keycloak(keycloakConfig);

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback) => {
  _kc
    .init({
      pkceMethod: 'S256',
      redirectUri,
      checkLoginIframe: false
      //   checkLoginIframe: true,
      //   checkLoginIframeInterval: 1
    })
    .then(onAuthenticatedCallback)
    .catch(console.error);
};

const doLogin = _kc.login;

const updatePasswordRedirect = () => {
  _kc.login({
    action: 'UPDATE_PASSWORD'
  });
};

const doLogout = _kc.logout;

const getToken = () => _kc.token;

const getTokenParsed = () => _kc.tokenParsed;

const isLoggedIn = () => !!_kc.token;

const isTokenExpireSoon = () => {
  if (isLoggedIn()) {
    const tokenParsed = _kc.tokenParsed;
    const currentTime = Math.floor(Date.now() / 1000);
    if (!tokenParsed) {
      return false;
    }
    const tokenExpiryTime = tokenParsed.exp;
    const timeLeft = tokenExpiryTime - currentTime;

    return timeLeft <= 100;
  } else {
    return false;
  }
};
const updateToken = async () => {
  try {
    return await _kc.updateToken(100);
  } catch (error) {
    doLogin();
  }
};

const KeycloakService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  getTokenParsed,
  updateToken,
  updatePasswordRedirect,
  isTokenExpireSoon
};

export default KeycloakService;
